<template>
  <div>
    <Row :gutter="20">
      <i-col :xs="12" :md="8" :lg="6" key="infor-1" style="height: 120px;padding-bottom: 10px;">
        <infor-card shadow color="#2d8cf0" icon="md-person-add" :icon-size="36">
          <count-to :end="statistics.users" count-class="count-style"/>
          <p>企业总数</p>
        </infor-card>
      </i-col>
      <i-col :xs="12" :md="8" :lg="6" key="infor-2" style="height: 120px;padding-bottom: 10px;">
        <infor-card shadow color="#19be6b" icon="md-cube" :icon-size="36">
          <count-to :end="statistics.jobs" count-class="count-style"/>
          <p>岗位总数</p>
        </infor-card>
      </i-col>
      <i-col :xs="12" :md="8" :lg="6" key="infor-3" style="height: 120px;padding-bottom: 10px;">
        <infor-card shadow color="#ff9900" icon="ios-paper" :icon-size="36">
          <count-to :end="statistics.applications" count-class="count-style"/>
          <p>个人总数</p>
        </infor-card>
      </i-col>
        <i-col :xs="12" :md="8" :lg="6" key="infor-4" style="height: 120px;padding-bottom: 10px;">
        <infor-card shadow color="#ed3f14" icon="md-trending-up" :icon-size="36">
          <count-to :end="statistics.interviews" count-class="count-style"/>
          <p>投简总数</p>
        </infor-card>
      </i-col>
    </Row>

<!--    <Row :gutter="20" style="margin-top: 10px;">-->
<!--      <i-col :md="24" :lg="16" style="margin-bottom: 10px;">-->
<!--        <Card shadow>-->
<!--          <p slot="title">-->
<!--            <Icon type="ios-trending-up"></Icon>-->
<!--            企业登录数-->
<!--          </p>-->
<!--          <chart-bar style="height: 340px;" :value="barData" text="近30天招聘数据"/>-->
<!--        </Card>-->
<!--      </i-col>-->

<!--      <i-col :md="24" :lg="8" style="margin-bottom: 10px;">-->
<!--        <Card shadow>-->
<!--          <p slot="title">-->
<!--            <Icon type="ios-notifications"></Icon>-->
<!--            系统通知-->
<!--          </p>-->
<!--          <List>-->
<!--            <ListItem v-for="(item, index) in notifications" :key="index">-->
<!--              <ListItemMeta :title="item.title">-->
<!--                <template slot="description">-->
<!--                  <span>{{ item.time }}</span>-->
<!--                </template>-->
<!--              </ListItemMeta>-->
<!--            </ListItem>-->
<!--          </List>-->
<!--        </Card>-->
<!--      </i-col>-->
<!--    </Row>-->

    <Row :gutter="20" style="margin-top: 10px;">
      <i-col :md="24" :lg="12" style="margin-bottom:10px;">
        <Card shadow>
          <p slot="title">
            <Icon type="ios-pie"></Icon>
            个人地区分布
          </p>
          <chart-pie ref="jobDistribution" style="height: 300px;" :value="pieJobData" text="个人地区分布"></chart-pie>
        </Card>
      </i-col>
      <i-col :md="24" :lg="12" style="margin-bottom: 10px;">
        <Card shadow>
          <p slot="title">
            <Icon type="ios-people"></Icon>
            企业地区分区
          </p>
          <chart-pie ref="industryDistribution" style="height: 300px;" :value="pieIndustryData" text="企业地区分区"></chart-pie>
        </Card>
      </i-col>
    </Row>

<!--    <Row :gutter="20" style="margin-top: 10px;">-->
<!--      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">-->
<!--        <Card shadow>-->
<!--          <p slot="title">-->
<!--            <Icon type="ios-list-box"></Icon>-->
<!--            最近招聘活动-->
<!--          </p>-->
<!--          <Table size="small" :columns="recentActivityColumns" :data="recentActivityData"></Table>-->
<!--          <div style="text-align: right; margin-top: 10px">-->
<!--            <Button type="primary" size="small">查看更多</Button>-->
<!--          </div>-->
<!--        </Card>-->
<!--      </i-col>-->
<!--    </Row>-->

  </div>
</template>

<script>
import InforCard from '_c/info-card'
import CountTo from '_c/count-to'
import { ChartPie, ChartBar } from '_c/charts'
import { getTagList, getTaskOrderlist, getTaskStatementlist } from '@/api/dashboard/home.js'
import { getZabbixLastissues } from '@/api/devops-tools'
import { getjoblist } from '@/api/apply/apply.js'
import { getcompanyinfo } from '@/api/company/company.js'
import {getinitStatistics} from '@/api/system/sys_parameter'
export default {
  name: 'home',
  components: {
    InforCard,
    ChartPie,
    ChartBar,
    CountTo
  },
  data () {
    return {
      statistics: {
        users: 0,
        jobs: 0,
        applications: 0,
        interviews: 0
      },
      pieJobData: [],
      pieIndustryData: [],
      notifications: [
        { title: '系统更新通知', time: '2023-05-20 10:30' },
        { title: '新增招聘会功能', time: '2023-05-18 09:15' },
        { title: '简历筛选功能优化', time: '2023-05-15 14:20' },
        { title: '系统维护公告', time: '2023-05-10 18:00' },
        { title: '数据安全更新', time: '2023-05-05 11:45' }
      ],
      barData: {},
      recentActivityColumns: [
        { title: '活动名称', key: 'name', align: 'center' },
        { title: '类型', key: 'type', align: 'center' },
        { title: '状态',
key: 'status',
align: 'center',
          render: (h, params) => {
            return h('Tag', {
              props: {
                color: params.row.statusColor
              }
            }, params.row.status)
          }
        },
        { title: '开始时间', key: 'startTime', align: 'center' },
        { title: '结束时间', key: 'endTime', align: 'center' },
        { title: '参与人数', key: 'participants', align: 'center' }
      ],
      recentActivityData: []
    }
  },
  methods: {
    // 初始化统计数据
    initStatistics () {
      // 这里应该从API获取实际数据，目前使用模拟数据
      // this.statistics = {
      //   users: 1258,
      //   jobs: 342,
      //   applications: 876,
      //   interviews: 215
      // }
      getinitStatistics('home', '10').then(res => {
          if (res.data.code === 0) {
            this.statistics = res.data.data
            this.pieIndustryData = res.data.pieIndustryData
            this.pieJobData = res.data.pieJobData
            this.recentActivityData = res.data.list
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
    },

    // 初始化职位分布饼图
    initPieJobData () {
      // 从API获取职位分类数据
      this.pieJobData = [
        { value: 35, name: '技术/IT' },
        { value: 20, name: '销售/市场' },
        { value: 15, name: '财务/金融' },
        { value: 10, name: '行政/人事' },
        { value: 20, name: '其他' }
      ]
    },

    // 初始化行业分布饼图
    initPieIndustryData () {
      // 从API获取行业分布数据
      this.pieIndustryData = [
        { value: 30, name: '互联网/IT' },
        { value: 25, name: '制造业' },
        { value: 15, name: '金融业' },
        { value: 10, name: '教育' },
        { value: 20, name: '其他' }
      ]
    },

    // 初始化近30天招聘趋势图
    initBarData () {
      // 生成近30天的日期和随机数据
      const days = []
      const data = []
      const now = new Date()
      for (let i = 29; i >= 0; i--) {
        const date = new Date(now)
        date.setDate(now.getDate() - i)
        const day = `${date.getMonth() + 1}/${date.getDate()}`
        days.push(day)
        data.push(Math.floor(Math.random() * 50) + 10)
      }

      // 构建图表数据
      const barData = {}
      days.forEach((day, index) => {
        barData[day] = data[index]
      })

      this.barData = barData
    },

    // 初始化最近招聘活动
    initRecentActivity () {
      // 模拟数据，实际应从API获取
      this.recentActivityData = [
        { name: '2023春季校园招聘', type: '校园招聘', status: '进行中', statusColor: 'success', startTime: '2023-05-10', endTime: '2023-06-10', participants: 156 },
        { name: 'IT技术人才专场', type: '专场招聘', status: '已结束', statusColor: 'default', startTime: '2023-04-15', endTime: '2023-05-15', participants: 89 },
        { name: '销售精英招募', type: '社会招聘', status: '计划中', statusColor: 'primary', startTime: '2023-06-01', endTime: '2023-06-30', participants: 0 },
        { name: '管理培训生项目', type: '校园招聘', status: '进行中', statusColor: 'success', startTime: '2023-05-01', endTime: '2023-06-15', participants: 210 },
        { name: '暑期实习生招聘', type: '实习招聘', status: '进行中', statusColor: 'success', startTime: '2023-05-20', endTime: '2023-06-20', participants: 75 }
      ]
    }
  },
  mounted () {
    this.initStatistics()
    // this.initPieJobData()
    // this.initPieIndustryData()
    // this.initBarData()
    // this.initRecentActivity()
  },
  watch: {
    pieJobData: function () {
      this.$refs.jobDistribution.initPie()
    },
    pieIndustryData: function () {
      this.$refs.industryDistribution.initPie()
    }
  }
}
</script>

<style lang="less">
.count-style{
  font-size: 30px;
  font-weight: bold;
}
</style>
